import React, { Component } from 'react'
import { Upload, message, Icon, Button, Checkbox } from 'antd'
import IssuesModel from '../models/IssuesModel'

const uploadOptions = {
    name: 'file',
    action: '//jsonplaceholder.typicode.com/posts/',
    headers: {
        authorization: 'authorization-text',
    },
    onChange(info) {
        if (info.file.status !== 'uploading') {
            //console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
            message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    }
}

class IssueUploadB extends Component {

    render() {
        const maxUploadSize = parseInt(IssuesModel.getMaxUploadSize() / 1000000, 10);
        return (
            <div>
                <strong>b.{' '}
                    <Checkbox checked={this.props.attach_b}
                        onChange={(e) => this.props.onChangeField('attach_b', e.target.checked)}>
                        Coordenadas da localização
                    </Checkbox>
                </strong>
                <br />
                <div style={{margin: '8px 0 16px 32px', display: this.props.attach_b ? 'block' : 'none'}}>
                    <Upload {...uploadOptions} id="upload">
                        <Button>
                          <Icon type="upload" /> Escolher gpx ou kml
                        </Button>
                    </Upload>
                    <p>Limite de tamanho de cada ficheiro a carregar: {maxUploadSize} MBytes</p>
                </div>
            </div>
        )
    }
}

export default IssueUploadB;



// WEBPACK FOOTER //
// ./src/components/IssueUploadB.js